import "./SuccessStories.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import ResultadosQueHablanPorSSolos from "./sections/ResultadosQueHablanPorSSolos";
import GalerAAntesYDespuS from "./sections/GalerAAntesYDespuS";
import HistoriasDeCambioReal from "./sections/HistoriasDeCambioReal";
import Patienttestimonials from "./sections/Patienttestimonials";
import Successcasesgrid from "./sections/Successcasesgrid";
import PieDePGinaInstitucional from "@/reusable_sections/Footer";
export default function SuccessStoriesPage() {
  return <div>
      <NavegaciNPrincipal />
      <ResultadosQueHablanPorSSolos />
      <Successcasesgrid />
      <GalerAAntesYDespuS />
      <HistoriasDeCambioReal />
      <Patienttestimonials />
      <PieDePGinaInstitucional />
    </div>;
}